// src/components/FancyButton.jsx
import React from "react";
import "../Button.css"; // Make sure to import the CSS file

const FancyButton = ({ children }) => {
  const handleClick = (e) => {
    e.preventDefault();
    const target = e.target;
    target.classList.remove("animate");
    target.classList.add("animate");
    setTimeout(() => {
      target.classList.remove("animate");
    }, 700);
  };

  return (
    <button className="bubbly-button" onClick={handleClick}>
      {children}
    </button>
  );
};

export default FancyButton;
